import {MoreVert} from "@mui/icons-material";
import {Chip, IconButton, Menu} from "@mui/material";
import React from "react";
import {EnlilTable} from "../EnlilTable";
import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import EventBus from "../../util/EventBus";
import css_buttons from "../Common/css/CCButton.module.scss";
import {Blue3} from "../../theme/styles";

class EmployeeTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("employee-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("employee-form-applet-save", this.onCancelHandler);
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("employee-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("employee-form-applet-save", this.onCancelHandler);
    }

    getCellRenderer(name) {
        if (name === "Action Cell") {
            return this.renderActionCell;
        }
        if (name === "Active Cell") {
            return this.renderActiveCell;
        }
        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        super.handleMenuClick(identifier);
    }

    renderExtension() {
    };

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderActiveCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let status;
        let backgroundColor;
        let content = [];

        if (this.state.buffer[params.row.id].get("Active") === true) {
            status = "ACTIVE";
            backgroundColor = Blue3;
            content.push(<Chip id="1" label={status} size="small" style={{minWidth: "80px", fontSize: 12, backgroundColor: backgroundColor, color: "#FFFFFF", marginTop: "1px", paddingTop: "2px"}}/>)
        } else {
            status = "INACTIVE";
            backgroundColor = "#BD2930"
            content.push(<Chip id="2" label={status} size="small" style={{minWidth: "80px", fontSize: 12, backgroundColor: backgroundColor, color: "#FFFFFF", marginTop: "1px", paddingTop: "2px"}}/>)
        }
        return (
            <div>
                {content}
            </div>
        );
    };

    renderActionCell = (instance, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", backgroundColor: "#FFFFFF", marginLeft: "-9px", paddingLeft: "8px", marginRight: "auto", marginTop: "auto", marginBottom: "auto", height: "100%"}}>
                <IconButton className={css_buttons.blueIconButton} onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                </Menu>
            </div>
        );
    };
}

export default withNavigate(withAppContext(withBreakpoint(EmployeeTable)));